//React Components and Hooks
import {
  CircularProgress as MuiCircularProgress,
  Divider as MuiDivider,
  Grid,
  Typography as MuiTypography,
} from "@mui/material";
//Material UI Components and Functions
import { makeStyles } from "@mui/styles";
import { spacing } from "@mui/system";
// Redux Components
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import StandardHeader from "../../components/global/StandardHeader";
// Custom application component imports:
import { LeftSidebar } from "layout-blueprints"; // The top navigation bar and side navigation panel
import {
  getAllPMStatusTypes,
  getAllPropertyPreviews,
} from "../../modules/apl/api/actions";
import { get as getAllPropManagers } from "../../modules/propertyManager/api/actions";
import PropertyManagerSearchTable from "../../modules/propertyManager/components/PropertyManagerSearchTable";
import { logout } from "../../modules/user/api/actions";


const Divider = styled(MuiDivider)(spacing);
const Typography = styled(MuiTypography)(spacing);
const CircularProgress = styled(MuiCircularProgress)(spacing);

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  percentDif: {
    textAlign: "right",
    color: "green",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  loadingIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const PropertyManagerSearchPage = (props) => {
  const classes = useStyles();

  const logout = () => {
    props.logout();
  };

  // On initial page load:
  useEffect(() => {
    props.getAllPropertyPreviews();
    props.getAllPMStatusTypes();
    document.title = "Property Managers";
  }, []);

  // On Data Loaded:
  return (
    <LeftSidebar>
      <StandardHeader
        title="Property Managers"
      />
      <Divider className="mb-3 mt-3" />
      <div style={{ width: '100%' }}>
        <PropertyManagerSearchTable />
      </div>
    </LeftSidebar>
  );
};

/* 
<Grid item xs={12} sm={12} md={12} lg={5} spacing={3}>
    <AccountsByPropertyTable/>
</Grid>
*/
// Component Properties
PropertyManagerSearchPage.propTypes = {
  user: PropTypes.object.isRequired,
  propertyManagers: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  getAllPropertyPreviews: PropTypes.func.isRequired,
  getAllPropManagers: PropTypes.func.isRequired,
  getAllPMStatusTypes: PropTypes.func.isRequired,
};

// Component State
function PropertyManagerSearchPageState(state) {
  return {
    user: state.user,
    apl: state.apl,
    billing: state.billing,
    accountsSearch: state.accountsSearch,
    propertyManagers: state.propertyManagers,
  };
}
export default connect(PropertyManagerSearchPageState, {
  logout,
  getAllPropertyPreviews,
  getAllPropManagers,
  getAllPMStatusTypes,
})(PropertyManagerSearchPage);
